export const SET_SERVICES_BY_CUSTOMER = "[VIEW_CUSTOMER] SET_SERVICES_BY_CUSTOMER";
export const SET_PAYMENTS_ORDER_BY_CUSTOMER = "[VIEW_CUSTOMER] SET_PAYMENTS_ORDER_BY_CUSTOMER";
export const SET_PAYMENT_PREFERENCE_OF_CUSTOMER =
  "[VIEW_CUSTOMER] SET_PAYMENT_PREFERENCE_OF_CUSTOMER";
export const CANCEL_SERVICE_OF_CUSTOMER = "[VIEW_CUSTOMER] CANCEL_SERVICE_OF_CUSTOMER";
